import { render } from "./alarms.vue?vue&type=template&id=c381a6b8&ts=true"
import script from "./alarms.vue?vue&type=script&lang=ts"
export * from "./alarms.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__